import Fuse from 'fuse.js';
import { useContext, useMemo } from 'react';

import { TeamsContext } from 'components/admin/users/teams_provider';

const TEAM_OPTIONS = {
  distance: 100,
  keys: ['name'],
  location: 0,
  shouldSort: true,
  threshold: 0.2,
};

export default function TeamSearch({ children }) {
  const teams = useContext(TeamsContext);
  const teamSearch = useMemo(() => {
    return new Fuse(teams, TEAM_OPTIONS);
  }, [teams]);

  return children({ teamSearch });
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/users/team_search.jsx